var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "emd-card",
    [
      _c(
        "emd-card-header",
        [
          _c("emd-text", { attrs: { size: "section" } }, [
            _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
          ]),
        ],
        1
      ),
      _c("emd-card-content", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("div", { staticClass: "image" }, [
              _c("img", {
                attrs: {
                  src: require(`@/assets/recipients-biometry/roller-guy.svg`)
                    .default,
                },
              }),
            ]),
            _c(
              "jade-text",
              { staticClass: "feedback", attrs: { variant: "heading-medium" } },
              [_vm._v(" " + _vm._s(_vm.$t("feedback")) + " ")]
            ),
            _c(
              "jade-text",
              { staticClass: "description", attrs: { variant: "text-medium" } },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("description-1", { name: _vm.name })) +
                    " "
                ),
                _c("b", [_vm._v(_vm._s(_vm.$t("description-2")))]),
                _vm._v(" " + _vm._s(_vm.$t("description-3")) + " "),
              ]
            ),
            _vm.error
              ? _c(
                  "jade-alert",
                  {
                    staticClass: "alert",
                    attrs: { variant: "negative", "show-icon": "" },
                  },
                  [
                    _c("jade-text", { attrs: { color: "negative" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("error-alert")) + " "),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _c("generate-link-button", {
              attrs: { id: _vm.id },
              on: {
                error: _vm.handleGenerateLinkError,
                generating: _vm.handleGenerating,
              },
              scopedSlots: _vm._u([
                {
                  key: "trail",
                  fn: function () {
                    return [
                      _c(
                        "jade-button",
                        {
                          staticClass: "button",
                          attrs: { size: "medium", variant: "primary-ghost" },
                          on: { click: _vm.redirectToDetails },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("validate-later")) + " ")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }